var link_viewer_default = {
  "fontElementMap": "_4NgzA",
  "link": "h-yF6",
  "linkInEditor": "MCILi",
  "linkInViewer": "ViOnt",
  "toolbarUrlContainer": "-vnJP",
  "toolbarUrl": "eD7xP",
  "toolbarUrlAnchor": "JTCft"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
